import ContactToken from '@apps/crm/admin/tokens/contact'
import DurationToken from '@admin/tokens/duration'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Carts)',
  collection: {
    endpoint: '/api/admin/team/affiliate/carts/active',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Contact)', key: 'contact.display_name', sort: 'last_name', primary: true, format: ({ contact }) => {
        return <ContactToken { ...contact } />
      } },
      { label: 't(Signup Page)', key: 'signup_page.title', sort: 'signup_page' },
      { label: 't(Agency)', key: 'owner.title', sort: 'agency' },
      { label: 't(Step)', key: 'status', collapsing: true },
      { label: 't(Age)', key: 'age', collapsing: true, wrap: false, align: 'right', format: (signup) => (
        <DurationToken duration={ signup.age } unit="minutes" />
      ) }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'shopping_cart',
      title: 't(No Carts)',
      text: 't(No one has started the signup process yet)'
    },
    entity: 'signup',
    recordTasks: (record) => [
      {
        label: 't(Copy Public URL)',
        svg: 'link2',
        handler: () => {
          navigator.clipboard.writeText(record.public_url)
          context.flash.set('success', 't(Public URL copied to clipboard)')
        }
      },
      {
        label: 't(Delete Cart)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this cart?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/signups/${record.id}`,
          method: 'DELETE',
          onSuccess: () => {},
          onFailure: () => {}
        }
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
